import React from 'react';
import { LayoutDashboard,Library,CreditCard ,Users,PenTool,LayoutGrid,SlidersHorizontal,Building2,SquarePlay,GitBranch,BookMarked,FilePen,Upload,Megaphone,BookOpen,BookText,BarChart2,ClipboardList,Landmark,Activity,Mail,MailPlus,ShieldCheck } from "lucide-react";
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const adminNavConfig = [
  {
    subheader: '',
    items: [
      {
        title: 'Dashboard',
        path: '/app/dashboard',
        icon: <LayoutDashboard size={22} />,
      },
    ],
  },

{
  subheader: 'CONTENT MANAGEMENT',
  items: [
    {
      title: 'Content Bank',
      path: '/app/content-bank',
      icon: <Library size={22} />,
    },

  
          {
            title: 'E-Books',
            path: '/app/ebook-list',
            icon: <BookText size={22} />,
          },
     

    {
      title: 'Plans & Pricing',
      path: '/app/subscription',
      icon: <CreditCard size={22} />,
    },
  ],
},

  {
    subheader: 'MASTER ORGANISATION',
    items: [
      {
        title: 'B2C Users',
        path: '/app/individual-users',
        icon: <Users size={22} />,
      },
      {
        title: 'Admin Users',
        path: '/app/admin-users',
        icon: <Megaphone size={22} />,
      },
      {
        title: 'Content Creators',
        path: '/app/content-writer-details',
        icon: <PenTool size={22} />,
      },
    ],
  },
  {
    subheader: 'CLIENT ADMINS',
    items: [
      //  {
      //   title: 'Client Reports',
      //   path: '/app/client-reports',
      //   icon: <Building2  size={22} />,
      // },
      {
        title: 'Client Admins',
        path: '/app/client-users',
        icon: <Building2  size={22} />,
      },
    ],
  },

  {
    subheader: 'COURSE CREATION',
    items: [
      {
        title: 'Create Course',
        path: '/app/course',
        icon: <SquarePlay size={22} />,
        // getIcon('bx:book-reader'),
      },
    ],
  },

  {
    subheader: 'ASSESSMENT CREATION',
    items: [
      {
        title: 'Sources & Chapters',
        path: '/app/sources',
        icon: <GitBranch size={22} />,
        // icon: getIcon('ph:book-open'),
      },
      {
        title: 'Question Bank',
        path: '/app/questions',
        icon: <BookMarked size={22} />,
        // icon: getIcon('ph:file-text'),
      },
     
      {
        title: 'Create Assessments',
        path: '/app/assessments',
        icon: <FilePen size={22} />,
        // icon: getIcon('mdi:file-document-edit-outline'),
      },
      {
        title: 'Bulk Upload',
        path: '/app/bulkUpload',
        icon: <Upload size={22} />,
        // icon: getIcon('ph:upload-simple'),
      },
    ],
  },

  // {
  //   subheader: 'REPORTS',
  //   items: [
  //     {
  //       title: 'Reports',
  //       path: '/app/reports',
  //       icon: getIcon('bi:bar-chart'),
  //       children: [
  //         { title: 'Trial Users', path: '/app/trial-users' },
  //         { title: 'Subscriptions', path: '/app/subscribed-users-new' },
  //         { title: 'User Course Progress', path: '/app/course-progress' },
  //         { title: 'SAT User Report', path: '/app/sat-report' },
  //       ],
  //     },
  //   ],
  // },

  // {
  //   subheader: 'SUPPORT',
  //   items: [
  //     {
  //       title: 'Tickets',
  //       path: '/app/feedback',
  //       icon: getIcon('fluent:person-feedback-24-regular'),
  //     },
  //   ],
  // },

  {
    subheader: 'ANALYTICS',
    items: [
      {
        title: 'Analytics',
        path: '/app/analytics',
        icon: <Activity size={22} />,
      },
       ...(process.env.REACT_APP_ENV === 'dev'
      ? [
              {
        title: 'Email Tracking',
        path: '/app/email-tracking',
        icon: <Mail size={22} />,
      },
        ]
      : []),
   
    ],
  },
  {
  subheader: 'CRISIS COMMUNICATION',
  items: [
    {
      title: 'User Status Activity',
      path: '/app/crisis-users',
      icon: <Mail size={22} />,
    },
    {
      title: 'Subscribed Users',
      path: '/app/subscribed-users',
      icon: <Mail size={22} />
    },
  ],
},


  {
    subheader: 'CONFIGURATION',
    items: [
      {
        title: 'Roles & Permissions',
        path: '/app/roles',
        icon: <ShieldCheck size={22} />,
      },
      {
        title: 'Email Templates',
        path: '/app/email-templates',
        icon: <MailPlus size={22} />,
      },
    
      {
        title: 'Marketing Config',
        path: '/app/settings',
        // icon: <SquarePlay size={22} />,
        icon: <Megaphone size={22} />,
      },
      {
        title: 'Platform Config',
        path: '/app/platformconfig',
        icon: <SlidersHorizontal  size={22} />,
      },
      {
        title: 'Dashboard Config',
        path: '/app/dashboardconfig',
        icon: <LayoutGrid size={22} />,
      },
        {
        title: 'Loginprofile Config',
        path: '/app/loginPageConfig',
        icon: <LayoutGrid size={22} />,
      },
    ],
  },

  // ── Secondary / detail pages (not shown in sidebar but listed here so the
  //    Roles drawer can grant or restrict access to them individually) ──────
  {
    subheader: 'USERS (DETAIL PAGES)',
    items: [
      { title: 'B2C User Profile', path: '/app/individual-usersview', icon: null },
      { title: 'Content Creator Profile', path: '/app/content-writer-detailsview', icon: null },
      { title: 'Client Detail', path: '/app/client-details', icon: null },
      { title: 'Client Reports', path: '/app/client-reports', icon: null },
      { title: 'Admin Account', path: '/app/account', icon: null },
    ],
  },

  {
    subheader: 'COURSE (DETAIL PAGES)',
    items: [
      { title: 'Course Type', path: '/app/course-type', icon: null },
      { title: 'Course Content', path: '/app/course-content', icon: null },
      { title: 'Sub-Module Details', path: '/app/submodules', icon: null },
      { title: 'Simulation Preview', path: '/app/simulation-preview', icon: null },
      { title: 'Client Course', path: '/app/client-course', icon: null },
      { title: 'Client Admin Course', path: '/app/client-Admin-course', icon: null },
      { title: 'Client Admin Assessment', path: '/app/client-Admin-assessment', icon: null },
      { title: 'Course Progress', path: '/app/course-progress', icon: null },
      { title: 'Text Editor', path: '/app/TextEditor', icon: null },
      { title: 'E-Book Creator', path: '/app/ebook-creator', icon: null },
      // Dynamic routes
      { title: 'E-Book Creator (Edit)', path: '/app/ebook-creator/:id', icon: null },
      { title: 'Source Chapters', path: '/app/source-chapters/:sourceId', icon: null },
      { title: 'Chapter Questions', path: '/app/chapter-questions/:chapterId', icon: null },
    ],
  },

  {
    subheader: 'ASSESSMENT (DETAIL PAGES)',
    items: [
      { title: 'Assessment Create', path: '/app/assessmentCreate', icon: null },
      { title: 'General Test', path: '/app/general-test', icon: null },
      { title: 'Question Create', path: '/app/question-create', icon: null },
      // Dynamic route
      { title: 'Question Edit', path: '/app/question-edit/:id', icon: null },
      { title: 'Question Details (MCQ)', path: '/app/question-details', icon: null },
      { title: 'Question Book', path: '/app/question-book', icon: null },
      { title: 'MCQ Multiple Upload', path: '/app/Mcqmultipleupload', icon: null },
      { title: 'Excel Upload', path: '/app/ExcelUpload', icon: null },
      { title: 'ChatBot Upload', path: '/app/ChatBotUpload', icon: null },
      { title: 'SAT Questions', path: '/app/satassessmentquestion', icon: null },
      { title: 'SAT Assessment', path: '/app/satassessment', icon: null },
      { title: 'SAT Assessment Edit', path: '/app/editSatassessment', icon: null },
      { title: 'SAT Page', path: '/app/satpage', icon: null },
      { title: 'SAT Report', path: '/app/sat-report', icon: null },
      { title: 'CLAT Main', path: '/app/CLAT', icon: null },
      { title: 'CLAT Create', path: '/app/clatmain', icon: null },
      { title: 'NEET Main', path: '/app/NEET', icon: null },
      { title: 'Add NEET', path: '/app/ADDNEET', icon: null },
      { title: 'NEET Assessment', path: '/app/ADDNEETAssessment', icon: null },
      { title: 'Edit NEET', path: '/app/EditNEET', icon: null },
      { title: 'Edit NEET Assessment', path: '/app/EditNEETAssessment', icon: null },
      { title: 'SkillIQ Test', path: '/app/skilliq-test', icon: null },
    ],
  },

  {
    subheader: 'REPORTS & TRIALS',
    items: [
      { title: 'Trial Users', path: '/app/trial-users', icon: null },
      { title: 'Subscribed Users', path: '/app/subscribed-users-new', icon: null },
      { title: 'User Details', path: '/app/user-details', icon: null },
      { title: 'Feedback', path: '/app/feedback', icon: null },
      { title: 'Database Visualizer', path: '/app/database', icon: null },
    ],
  },

  {
    subheader: 'PLANS (DETAIL PAGES)',
    items: [
      { title: 'Create Assessment Plan', path: '/app/subscription/create/assessment', icon: null },
      { title: 'Create Single Course Plan', path: '/app/subscription/create/single', icon: null },
      { title: 'Create Bundle Plan', path: '/app/subscription/create/bundle', icon: null },
      { title: 'Create B2B Plan', path: '/app/subscription/create/b2b', icon: null },
      { title: 'Create E-Books Plan', path: '/app/subscription/create/ebooks', icon: null },
      // Dynamic route — covers /app/subscription/assessment/123, /app/subscription/bundle/456, etc.
      { title: 'Plan Detail (View/Edit)', path: '/app/subscription/:planType/:id', icon: null },
    ],
  },

  {
    subheader: 'SETTINGS (DETAIL PAGES)',
    items: [
      { title: 'View Settings', path: '/app/view-Settings', icon: null },
      { title: 'Add Settings', path: '/app/add-Settings', icon: null },
    ],
  },

  // ── Secondary / detail pages (not shown in sidebar but listed here so the
  //    Roles drawer can grant or restrict access to them individually) ──────
  {
    subheader: 'USERS (DETAIL PAGES)',
    items: [
      { title: 'B2C User Profile', path: '/app/individual-usersview', icon: null },
      { title: 'Content Creator Profile', path: '/app/content-writer-detailsview', icon: null },
      { title: 'Client Detail', path: '/app/client-details', icon: null },
      { title: 'Client Reports', path: '/app/client-reports', icon: null },
      { title: 'Admin Account', path: '/app/account', icon: null },
    ],
  },

  {
    subheader: 'COURSE (DETAIL PAGES)',
    items: [
      { title: 'Course Type', path: '/app/course-type', icon: null },
      { title: 'Course Content', path: '/app/course-content', icon: null },
      { title: 'Sub-Module Details', path: '/app/submodules', icon: null },
      { title: 'Simulation Preview', path: '/app/simulation-preview', icon: null },
      { title: 'Client Course', path: '/app/client-course', icon: null },
      { title: 'Client Admin Course', path: '/app/client-Admin-course', icon: null },
      { title: 'Client Admin Assessment', path: '/app/client-Admin-assessment', icon: null },
      { title: 'Course Progress', path: '/app/course-progress', icon: null },
      { title: 'Text Editor', path: '/app/TextEditor', icon: null },
      { title: 'E-Book Creator', path: '/app/ebook-creator', icon: null },
      // Dynamic routes
      { title: 'E-Book Creator (Edit)', path: '/app/ebook-creator/:id', icon: null },
      { title: 'Source Chapters', path: '/app/source-chapters/:sourceId', icon: null },
      { title: 'Chapter Questions', path: '/app/chapter-questions/:chapterId', icon: null },
    ],
  },

  {
    subheader: 'ASSESSMENT (DETAIL PAGES)',
    items: [
      { title: 'Assessment Create', path: '/app/assessmentCreate', icon: null },
      { title: 'General Test', path: '/app/general-test', icon: null },
      { title: 'Question Create', path: '/app/question-create', icon: null },
      // Dynamic route
      { title: 'Question Edit', path: '/app/question-edit/:id', icon: null },
      { title: 'Question Details (MCQ)', path: '/app/question-details', icon: null },
      { title: 'Question Book', path: '/app/question-book', icon: null },
      { title: 'MCQ Multiple Upload', path: '/app/Mcqmultipleupload', icon: null },
      { title: 'Excel Upload', path: '/app/ExcelUpload', icon: null },
      { title: 'ChatBot Upload', path: '/app/ChatBotUpload', icon: null },
      { title: 'SAT Questions', path: '/app/satassessmentquestion', icon: null },
      { title: 'SAT Assessment', path: '/app/satassessment', icon: null },
      { title: 'SAT Assessment Edit', path: '/app/editSatassessment', icon: null },
      { title: 'SAT Page', path: '/app/satpage', icon: null },
      { title: 'SAT Report', path: '/app/sat-report', icon: null },
      { title: 'CLAT Main', path: '/app/CLAT', icon: null },
      { title: 'CLAT Create', path: '/app/clatmain', icon: null },
      { title: 'NEET Main', path: '/app/NEET', icon: null },
      { title: 'Add NEET', path: '/app/ADDNEET', icon: null },
      { title: 'NEET Assessment', path: '/app/ADDNEETAssessment', icon: null },
      { title: 'Edit NEET', path: '/app/EditNEET', icon: null },
      { title: 'Edit NEET Assessment', path: '/app/EditNEETAssessment', icon: null },
      { title: 'SkillIQ Test', path: '/app/skilliq-test', icon: null },
    ],
  },

  {
    subheader: 'REPORTS & TRIALS',
    items: [
      { title: 'Trial Users', path: '/app/trial-users', icon: null },
      { title: 'Subscribed Users', path: '/app/subscribed-users-new', icon: null },
      { title: 'User Details', path: '/app/user-details', icon: null },
      { title: 'Feedback', path: '/app/feedback', icon: null },
      { title: 'Database Visualizer', path: '/app/database', icon: null },
    ],
  },

  {
    subheader: 'PLANS (DETAIL PAGES)',
    items: [
      { title: 'Create Assessment Plan', path: '/app/subscription/create/assessment', icon: null },
      { title: 'Create Single Course Plan', path: '/app/subscription/create/single', icon: null },
      { title: 'Create Bundle Plan', path: '/app/subscription/create/bundle', icon: null },
      { title: 'Create B2B Plan', path: '/app/subscription/create/b2b', icon: null },
      { title: 'Create E-Books Plan', path: '/app/subscription/create/ebooks', icon: null },
      // Dynamic route — covers /app/subscription/assessment/123, /app/subscription/bundle/456, etc.
      { title: 'Plan Detail (View/Edit)', path: '/app/subscription/:planType/:id', icon: null },
    ],
  },

  {
    subheader: 'SETTINGS (DETAIL PAGES)',
    items: [
      { title: 'View Settings', path: '/app/view-Settings', icon: null },
      { title: 'Add Settings', path: '/app/add-Settings', icon: null },
    ],
  },
];

const contentNavConfig = [{
    subheader: '',
    items: [
      {
        title: 'Dashboard',
        path: '/app/dashboard',
        icon: <LayoutDashboard size={22} />,
      },
    ],
  },

  {
    subheader: 'COURSE MANAGEMENT',
    items: [
      {
        title: 'Courses',
        path: '/app/course',
        icon: <SquarePlay size={22} />,
      },
    
          {
            title: 'E-Books',
            path: '/app/ebook-list',
            icon: <BookText size={22} />,
          },
     
    ],
  },

  {
    subheader: 'ASSESSMENT MANAGEMENT',
    items: [
      {
        title: 'Sources & Chapters',
        path: '/app/sources',
        icon: <GitBranch size={22} />,
      },
      {
        title: 'Questions',
        path: '/app/questions',
        icon: <BookMarked size={22} />,
      },
      {
        title: 'Assessments',
        path: '/app/assessments',
        icon: <FilePen size={22} />,
      },
      {
        title: 'Bulk Import',
        path: '/app/bulkUpload',
        icon: <Upload size={22} />,
      },
       {
        title: 'Platform Config',
        path: '/app/platformconfig',
        icon: <SlidersHorizontal  size={22} />,
      }
    
    ],
  },

  // ── Secondary / detail pages ─────────────────────────────────────────────
  {
    subheader: 'DETAIL PAGES',
    items: [
      { title: 'Assessment Create', path: '/app/assessmentCreate', icon: null },
      { title: 'General Test', path: '/app/general-test', icon: null },
      { title: 'Question Create', path: '/app/question-create', icon: null },
      { title: 'Question Details (MCQ)', path: '/app/question-details', icon: null },
      { title: 'Question Book', path: '/app/question-book', icon: null },
      { title: 'MCQ Multiple Upload', path: '/app/Mcqmultipleupload', icon: null },
      { title: 'Excel Upload', path: '/app/ExcelUpload', icon: null },
      { title: 'ChatBot Upload', path: '/app/ChatBotUpload', icon: null },
      { title: 'SAT Questions', path: '/app/satassessmentquestion', icon: null },
      { title: 'SAT Assessment', path: '/app/satassessment', icon: null },
      { title: 'SAT Assessment Edit', path: '/app/editSatassessment', icon: null },
      { title: 'SAT Page', path: '/app/satpage', icon: null },
      { title: 'CLAT Main', path: '/app/CLAT', icon: null },
      { title: 'CLAT Create', path: '/app/clatmain', icon: null },
      { title: 'NEET Main', path: '/app/NEET', icon: null },
      { title: 'Add NEET', path: '/app/ADDNEET', icon: null },
      { title: 'NEET Assessment', path: '/app/ADDNEETAssessment', icon: null },
      { title: 'Edit NEET', path: '/app/EditNEET', icon: null },
      { title: 'Edit NEET Assessment', path: '/app/EditNEETAssessment', icon: null },
      { title: 'Course Type', path: '/app/course-type', icon: null },
      { title: 'Course Content', path: '/app/course-content', icon: null },
      { title: 'Sub-Module Details', path: '/app/submodules', icon: null },
      { title: 'Simulation Preview', path: '/app/simulation-preview', icon: null },
      { title: 'View Settings', path: '/app/view-Settings', icon: null },
      { title: 'E-Book Creator', path: '/app/ebook-creator', icon: null },
      { title: 'E-Book Creator (Edit)', path: '/app/ebook-creator/:id', icon: null },
      { title: 'Source Chapters', path: '/app/source-chapters/:sourceId', icon: null },
      { title: 'Chapter Questions', path: '/app/chapter-questions/:chapterId', icon: null },
      { title: 'Question Edit', path: '/app/question-edit/:id', icon: null },
      { title: 'SkillIQ Test', path: '/app/skilliq-test', icon: null },
      { title: 'Export Data', path: '/app/exportdata', icon: null },
      { title: 'Text Editor', path: '/app/TextEditor', icon: null },
      { title: 'Account', path: '/app/account', icon: null },
    ],
  },
];

const clientNavConfig = [
  {
    subheader: '',
    items: [
      { title: 'Dashboard', path: '/app/dashboard', icon: <LayoutDashboard size={22} /> },
    ],
  },
  {
    subheader: 'ORGANISATION',
    items: [
      { title: 'Departments & Teams', path: '/app/org', icon: <Building2 size={22} /> },
    ],
  },
  {
    subheader: 'PEOPLE',
    items: [
      { title: 'Learners', path: '/app/learners', icon: <Users size={22} /> },
      // { title: 'Schedule Details', path: '/app/scheduledetails', icon: <Users size={22} /> },
    ],
  },
  {
    subheader: 'CONTENT',
    items: [
      { title: 'Global Catalog', path: '/app/catalog', icon: <BookOpen size={22} /> },
      { title: 'Content Bank', path: '/app/content-bank', icon: <Library size={22} /> },
    ],
  },
  {
    subheader: 'INSIGHTS',
    items: [
      { title: 'Reports', path: '/app/reports', icon: <BarChart2 size={22} /> },
    ],
  },
  {
    subheader: 'COMMUNICATION',
    items: [
      { title: 'Announcements', path: '/app/announcement', icon: <Megaphone size={22} /> },
    ],
  },
  // {
  //   subheader: 'MONITORING',
  //   items: [
  //     { title: 'Proctoring', path: '/app/proctoring', icon: <Eye size={22} /> },
  //   ],
  // },
  {
    subheader: 'SETTINGS',
    items: [
      { title: 'Users & Roles', path: '/app/users-roles', icon: <Users size={22} /> },
      { title: 'Audit Log', path: '/app/audit-log', icon: <ClipboardList size={22} /> },
      { title: 'Billing', path: '/app/billing', icon: <Landmark size={22} /> },
    ],
  },

  // ── Secondary / detail pages (not shown in sidebar but listed here so the
  //    Roles drawer can grant or restrict access to them individually) ──────
  {
    subheader: 'DETAIL PAGES',
    items: [
      { title: 'User List', path: '/app/users', icon: null },
      { title: 'User Profile', path: '/app/UserProfile', icon: null },
      { title: 'Learner Profile', path: '/app/learner-profile', icon: null },
      { title: 'User Table', path: '/app/user-table', icon: null },
      { title: 'Courses', path: '/app/course', icon: null },
      { title: 'Course Content', path: '/app/client-course-content', icon: null },
      { title: 'Assessment Content', path: '/app/client-assessment-content', icon: null },
      { title: 'Course Content (Edit)', path: '/app/course-content', icon: null },
      { title: 'Simulation Preview', path: '/app/simulation-preview', icon: null },
      { title: 'Account', path: '/app/account', icon: null },
      { title: 'Analytics', path: '/app/analytics', icon: null },
      { title: 'Analytics Details', path: '/app/analytics-details', icon: null },
      { title: 'Courses Analytics Tab', path: '/app/courses-analyticstab', icon: null },
      { title: 'Case Studies Tab', path: '/app/case-studiestab', icon: null },
      { title: 'Assessments', path: '/app/assessments', icon: null },
      { title: 'Proctoring', path: '/app/proctoring', icon: null },
    ],
  },
];
// const clientNavConfig = [
//   {
//     title: 'Dashboard',
//     path: '/app/dashboard',
//     icon: getIcon('akar-icons:dashboard'),
//   },
//   {
//     title: 'Users',
//     path: '/app/users',
//     icon: getIcon('ph:users-three-bold'),
//   },
//   {
//     title: 'Courses',
//     path: '/app/course',
//     icon: getIcon('bx:book-reader'),
//   },
//   {
//     title: 'Assessments',
//     path: '/app/assessments',
//     icon: getIcon('mdi:file-document-edit-outline'),
//   },
//   {
//     title: 'Analytics',
//     path: '/app/analytics',
//     icon: getIcon('bi:bar-chart'),
//   },
// ];

const managerNavConfig = [
  {
    subheader: '',
    items: [
      { title: 'Dashboard', path: '/app/dashboard', icon: <LayoutDashboard size={22} /> },
    ],
  },
  {
    subheader: 'ORGANISATION',
    items: [
      { title: 'Departments & Teams', path: '/app/org', icon: <Building2 size={22} /> },
    ],
  },
  {
    subheader: 'PEOPLE',
    items: [
      { title: 'Learners', path: '/app/learners', icon: <Users size={22} /> },
    ],
  },
  {
    subheader: 'CONTENT',
    items: [
      { title: 'Global Catalog', path: '/app/catalog', icon: <BookOpen size={22} /> },
    ],
  },
  {
    subheader: 'INSIGHTS',
    items: [
      { title: 'Reports', path: '/app/reports', icon: <BarChart2 size={22} /> },
    ],
  },
  {
    subheader: 'COMMUNICATION',
    items: [
      { title: 'Announcements', path: '/app/announcement', icon: <Megaphone size={22} /> },
    ],
  },
  // {
  //   subheader: 'MONITORING',
  //   items: [
  //     { title: 'Proctoring', path: '/app/proctoring', icon: <Eye size={22} /> },
  //   ],
  // },
];

export default {
  adminNavConfig,
  clientNavConfig,
  contentNavConfig,
  managerNavConfig,
};
